import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';
import { TZDate } from '@date-fns/tz';
import { UTCDate } from '@date-fns/utc';

@Pipe({
    name: 'convertUTC',
    standalone: true,
})
export class ConvertUTCPipe implements PipeTransform {
  transform(value: Date, timeZone: string): string {
    if (value && timeZone) {
      // Convert the input date to UTC first, then to the target timezone
      const utcDate = new UTCDate(value);
      const zonedDate = new TZDate(utcDate, timeZone);

      // Format time part (without timezone)
      const timeString = format(zonedDate, 'h:mm a');

      // Get timezone abbreviation using Intl.DateTimeFormat
      const tzAbbr = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        timeZoneName: 'short'
      }).formatToParts(zonedDate.getTime()).find(part => part.type === 'timeZoneName')?.value || timeZone;

      return `${timeString} ${tzAbbr}`.toUpperCase().replace('AM', 'AM').replace('PM', 'PM');
    }
    return '';
  }
}
